.input {
    margin-bottom: var(--mantine-spacing-xs);
    border-radius: var(--mantine-radius-md) 0 0 var(--mantine-radius-md);
    max-width: var(--mantine-breakpoint-sm);
}

.group {
    gap: 0;
    align-items: end;
    margin-top: var(--mantine-spacing-sm);
    width: 100%;
    flex-wrap: nowrap;
}

.inputBox {
    flex: 1 1 auto;
    min-width: 100px;
}

.label {
    text-align: left;
    font-weight: var(--mantine-font-weight-heavy);
    font-size: var(--mantine-font-size-sm);
}

.selectRoot {
    flex: 0 1 auto;
    min-width: none;
}
